import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import SwiperCore, {
  Autoplay,
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
} from "swiper";
import "./SmSlider.css";
import cardioJpg from "./../../images/smSlides/cardio.jpg";
import absJpg from "./../../images/smSlides/abs.jpg";
import gymJpg from "./../../images/smSlides/gym.jpg";
import yogaJpg from "./../../images/smSlides/yoga.jpg";
import karateJpg from "./../../images/smSlides/karate.jpg";
import pushUpJpg from "./../../images/smSlides/pushup.jpg";
import harleyJpg from "./../../images/smSlides/harley.jpg";
import girlGym from "./../../images/smSlides/girlGym.jpg";
import groupGym from "./../../images/smSlides/groupGym.jpg";
import girl2Jpg from "./../../images/smSlides/girl2.jpg";
import gymBoy from "./../../images/smSlides/gymBoy.jpg";
import greetJpg from "./../../images/smSlides/greet.jpg";

SwiperCore.use([Autoplay, Navigation, Pagination, Scrollbar, A11y]);

const SmSlider = () => {
  const slides = [
    { title: "First item", description: "Lorem ipsum" },
    { title: "Second item", description: "Lorem ipsum" },
  ];

  return (
    <div className="sm_slider">
      <Swiper
        spaceBetween={10}
        slidesPerView={"auto"}
        loop={true}
        autoplay={{
          delay: 1000,
          disableOnInteraction: false,
        }}
        // onSwiper={(swiper) => console.log(swiper)}
        // onSlideChange={() => console.log("slide change")}
      >
        <SwiperSlide>
          <img
            src={cardioJpg}
            width="300"
            height="200"
            className="rounded"
            style={{ cursor: "pointer" }}
            alt="cardio"
          />
        </SwiperSlide>

        <SwiperSlide>
          <img
            src={absJpg}
            width="300"
            height="200"
            className="rounded"
            style={{ cursor: "pointer" }}
            alt="cardio"
          />
        </SwiperSlide>

        <SwiperSlide>
          <img
            src={gymJpg}
            width="300"
            height="200"
            className="rounded"
            style={{ cursor: "pointer" }}
            alt="cardio"
          />
        </SwiperSlide>

        <SwiperSlide>
          <img
            src={yogaJpg}
            width="300"
            height="200"
            className="rounded"
            style={{ cursor: "pointer" }}
            alt="cardio"
          />
        </SwiperSlide>

        <SwiperSlide>
          <img
            src={karateJpg}
            width="300"
            height="200"
            className="rounded"
            style={{ cursor: "pointer" }}
            alt="cardio"
          />
        </SwiperSlide>

        <SwiperSlide>
          <img
            src={pushUpJpg}
            width="300"
            height="200"
            className="rounded"
            style={{ cursor: "pointer" }}
            alt="cardio"
          />
        </SwiperSlide>

        <SwiperSlide>
          <img
            src={harleyJpg}
            width="300"
            height="200"
            className="rounded"
            style={{ cursor: "pointer" }}
            alt="cardio"
          />
        </SwiperSlide>

        <SwiperSlide>
          <img
            src={girlGym}
            width="300"
            height="200"
            className="rounded"
            style={{ cursor: "pointer" }}
            alt="cardio"
          />
        </SwiperSlide>

        <SwiperSlide>
          <img
            src={groupGym}
            width="300"
            height="200"
            className="rounded"
            style={{ cursor: "pointer" }}
            alt="cardio"
          />
        </SwiperSlide>

        <SwiperSlide>
          <img
            src={girl2Jpg}
            width="300"
            height="200"
            className="rounded"
            style={{ cursor: "pointer" }}
            alt="cardio"
          />
        </SwiperSlide>

        <SwiperSlide>
          <img
            src={gymBoy}
            width="300"
            height="200"
            className="rounded"
            style={{ cursor: "pointer" }}
            alt="cardio"
          />
        </SwiperSlide>

        <SwiperSlide>
          <img
            src={greetJpg}
            width="300"
            height="200"
            className="rounded"
            style={{ cursor: "pointer" }}
            alt="cardio"
          />
        </SwiperSlide>

        {/* <SwiperSlide>Slide 2</SwiperSlide>
        <SwiperSlide>Slide 3</SwiperSlide>
        <SwiperSlide>Slide 4</SwiperSlide>
        <SwiperSlide>Slide 5</SwiperSlide>
        <SwiperSlide>Slide 6</SwiperSlide>
        <SwiperSlide>Slide 7</SwiperSlide>
        <SwiperSlide>Slide 8</SwiperSlide>
        <SwiperSlide>Slide 9</SwiperSlide>
        <SwiperSlide>Slide 10</SwiperSlide> */}
      </Swiper>
    </div>
  );
};

export default SmSlider;
